// extracted by mini-css-extract-plugin
module.exports = {"bubble":"bubble_bubble__Zpq6_"};